export default __webpack_public_path__ + "static/media/stop_icon.318ad90d.svg";